export default __webpack_public_path__ + "static/media/secondwind.9f61c711.png";